import { Component } from '@angular/core';

@Component({
  selector: 'line-separator-component-preview',
  templateUrl: './line-separator-component-preview.component.html',
  styleUrls: ['./line-separator-component-preview.component.scss'],
  standalone: false,
})
export class LineSeparatorComponentPreviewComponent {}
